import { apiJsonOrThrow } from "./adminUtils";

export const ARTIFACT_TEMPLATE_KINDS = [
  {
    id: "solution_blueprint",
    label: "Solution Blueprint",
    short: "Blueprint",
  },
];

export async function listArtifactTemplates(kind) {
  const params = new URLSearchParams({ _t: String(Date.now()) });
  if (kind) params.set("kind", kind);
  return apiJsonOrThrow(`/api/artifact-templates?${params.toString()}`);
}

export async function createArtifactTemplateFromText({
  kind,
  name,
  source_text,
  activate = true,
}) {
  return apiJsonOrThrow("/api/artifact-templates", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ kind, name, source_text, activate }),
  });
}

export async function uploadArtifactTemplate({
  kind,
  name,
  file,
  activate = true,
}) {
  const form = new FormData();
  form.append("kind", kind);
  form.append("name", name);
  form.append("activate", String(Boolean(activate)));
  form.append("file", file);
  return apiJsonOrThrow("/api/artifact-templates/upload", {
    method: "POST",
    body: form,
  });
}

export async function previewCompileArtifactTemplate({
  kind,
  name,
  source_text,
}) {
  return apiJsonOrThrow("/api/artifact-templates/preview-compile", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ kind, name, source_text, activate: false }),
  });
}

export async function activateArtifactTemplate(templateId) {
  return apiJsonOrThrow(
    `/api/artifact-templates/${encodeURIComponent(templateId)}/activate`,
    { method: "POST" }
  );
}

export async function deactivateArtifactKind(kind) {
  const form = new FormData();
  form.append("kind", kind);
  return apiJsonOrThrow("/api/artifact-templates/deactivate", {
    method: "POST",
    body: form,
  });
}

export async function deleteArtifactTemplate(templateId) {
  return apiJsonOrThrow(
    `/api/artifact-templates/${encodeURIComponent(templateId)}/delete`,
    { method: "POST" }
  );
}
